import { render, staticRenderFns } from "./BatchQrcode.vue?vue&type=template&id=33ed4a33&scoped=true"
import script from "./BatchQrcode.vue?vue&type=script&lang=js"
export * from "./BatchQrcode.vue?vue&type=script&lang=js"
import style0 from "./BatchQrcode.vue?vue&type=style&index=0&id=33ed4a33&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ed4a33",
  null
  
)

export default component.exports